document.addEventListener("DOMContentLoaded", function () {
    height = window.innerHeight;
    document.documentElement.style.setProperty( '--vh', height/100 + 'px');
});

// let vh = window.innerHeight * 0.01;
// document.documentElement.style.setProperty('--vh', `${vh}px`);

// レビュー
let str = 'Write a Review';
let newstr = str.replace('Write a Review', 'レビューを記入');